site.nav = {
	// Init navigation scripts
	init: function() {
		var $html = $('<div id="mMenu" role="navigation"></div>');
		var $mMenu = $('#mainmenu').find('.mmLevel1').clone().removeAttr('id');
		$html.append($mMenu);
		$('body').append($html);

		// Add expand link to mobile menu
		$('.children', '#mMenu ').prepend('<span class="expand"><i class="fa fa-angle-down"></span>');
		$('.selectedLevel1','#mMenu').addClass('down');
		$('.selectedLevel2','#mMenu').addClass('down');
		$('.selectedLevel3','#mMenu').addClass('down');
		$('.selectedLevel4','#mMenu').addClass('down');
		site.nav.bind();
		site.nav.mobileSearch();
		site.nav.appendLanguage();
		//site.nav.appendQn();

		$('ul', '#mMenu').removeAttr('id');
	},
	bind: function() {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function(e) {
			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('mainmenu-open');
			site.nav.mobileToggle(e, menuOpen);

			$('#mMenu').on('click', function(e) {
				e.stopPropagation();
			});

			$('body.mainmenu-open').on('click', function (e) {
				$('body').removeClass('mainmenu-open');
			});


		});

		// Expand in mobile menu
		$('.expand', '#mMenu').bind('click', function(e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
	},
	// Toggle mobile menu
	mobileToggle: function(e, menuOpen) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
	},

	// Append language to site
	appendLanguage: function() {
		var $divisions = $.merge($('ul:last-child a', "#qn"), $("ul:first-child a", "#qn"));
		var $menu = $('ul.mmLevel1', '#mMenu');
		
		$divisions.each(function () {
			var $this = $(this),
				$item = $(this).clone().text($this.attr('title'));
			$menu.append('<li class="level1 el-language">' + $item.prop('outerHTML') + '</li>');
		});
	},

	appendQn: function() {
		var $menu = $('#mMenu'),
			$qn = $('.qn2 ul', '#qn').clone().addClass('menu');
		$('li', $qn).addClass('level1');
		$menu.append($qn);
	},

	mobileSearch: function() {
		var $mmenu = $('#mMenu'),
			$mSearchBox = $('.searchFormWrap').clone();
		$mmenu.prepend($mSearchBox);

		$('[id]', $mSearchBox).each(function() {
			var $this = $(this),
				$id = $this.attr('id'),
				$newId = 'm'+$id.substr(0,1).toUpperCase()+$id.substr(1),
				$label = $('label[for="'+$id+'"]', $mSearchBox);

			if ($label.length > 0) {
				$label.attr('for', $newId);
			}
			$this.attr('id', $newId);

			if (typeof $this.attr('name') !== typeof undefined) {
				$this.attr('name', $newId);
			}
		});
	}
};

site.inits.push('site.nav.init()');
